module.exports = __webpack_public_path__ + "static/media/hospitalAlcaldesa.beabcee5.mp3";